export const marketCategory = [
  {
    category_id: 'attar23346',
    categoryname: 'Rice, Dal, Atta, Oil',
    image: require('../assets/category/attanOil.png'),
  },
  {
    category_id: 'masal73543',
    categoryname: 'Masala & Dry Fruits',
    image: require('../assets/category/masaladryfruits.png'),
  },
  {
    category_id: 'dairy64076',
    categoryname: 'Dairy, Tea & Drinks',
    image: require('../assets/category/teacoffee.png'),
  },
  {
    category_id: 'biscu15589',
    categoryname: 'Biscuits & Snacks',
    image: require('../assets/category/biscuitsNcookies.png'),
  },

  {
    category_id: 'bath,26350',
    categoryname: 'Bath, Body & Hair',
    image: require('../assets/category/bathNbody.png'),
  },
  {
    category_id: 'makeu93103',
    categoryname: 'Cosmetics',
    image: require('../assets/category/makeup.png'),
  },
  // {
  //   category_id: 'hygie19570',
  //   categoryname: 'Personal Care',
  //   image: require('../assets/category/HygieneWellness.png'),
  // },

  // {
  //   "category_id":"break52600",
  //   "categoryname": "Breakfast & Sauces",
  //   "image": require("../assets/category/brealfastNsouces.png")
  // },
  {
    category_id: 'babyc42146',
    categoryname: 'Baby Food & Care',
    image: require('../assets/category/babycare.png'),
  },
  {
    category_id: 'clean10142',
    categoryname: 'Cleaning Essentials',
    image: require('../assets/category/cleaningEsse.png'),
  },
  {
    category_id: 'homen70647',
    categoryname: 'Home Essentials',
    image: require('../assets/category/homeNeeds.png'),
  },
  // {
  //   "category_id":"coldd37594",
  //   "categoryname": "Cold Drinks & Juices",
  //   "image": require("../assets/category/colddrinksNjuices.png")
  // },

  // {
  //   "category_id":"froze52579",
  //   "categoryname": "Frozen Food & Ice Creams",
  //   "image": require("../assets/category/frozenfood.png")
  // },
  {
    category_id: 'fruit20420',
    categoryname: 'Fruits & Vegetables',
    image: require('../assets/category/fruitsNveggies.png'),
  },
  {
    category_id: 'pooja9554',
    categoryname: 'Pooja & Festivals',
    image: require('../assets/category/pooja.jpg'),
  },
  {
    category_id: 'food&sweet',
    categoryname: 'Food & Sweets',
    image: require('../assets/category/food&sweet.png'),
  },
  // {
  //   category_id: 'shopbybrand',
  //   categoryname: 'Shop By Brand',
  //   image: require('../assets/category/2.png'),
  // },
  // {
  //   "category_id":"groom1229",
  //   "categoryname": "Grooming Essentials",
  //   "image": require("../assets/category/GroomingEssentials.png")
  // },
  // {
  //   "category_id":"meats80643",
  //   "categoryname": "Meats, Fish & Eggs",
  //   "image": require("../assets/category/meatsFishEgg.png")
  // },
  // {
  //   "category_id":"munch23538",
  //   "categoryname": "Munchies & Chips",
  //   "image": require("../assets/category/munchis.png")
  // },
  // {
  //   "category_id":"packa64266",
  //   "categoryname": "Packaged Food",
  //   "image": require("../assets/category/packagedfood.png")
  // },
  // {
  //   "category_id":"skinc16134",
  //   "categoryname": "Skincare",
  //   "image": require("../assets/category/skineCare.png")
  // },
  // {
  //   "category_id":"sweet36873",
  //   "categoryname": "Sweet Cravings",
  //   "image": require("../assets/category/sweetcravings.png")
  // },
];
